export default __webpack_public_path__ + "static/media/avalog-logo.ebabeb0b.png";